import React, { useEffect, useState } from "react";
import "./css/login.css";
import { Link } from "react-router-dom";
import { API_BASE_URL } from "../api";


function Login() {
    const [name, setName] = useState("");
    const [password, setPassword] = useState("");
    const [privacyAccepted, setPrivacyAccepted] = useState(false);
    const [alertMessage, setAlertMessage] = useState("");
    const [loading, setLoading] = useState(false);
    const [showImprint, setShowImprint] = useState(true);

    useEffect(() => {
        document.title = "Login | James Schreiber Portfolio";
    }, []);

    useEffect(() => {
        console.log("Login Seite geladen");


        const session = localStorage.getItem("session");
        if (session) {
            window.location.href = "/";
        }
    }, []);

    useEffect(() => {
        async function loadLegalSettings() {
            try {
                const response = await fetch(`${API_BASE_URL}/api/legal`);
                const data = await response.json();
                setShowImprint(data.pages?.imprint?.visible !== false);
            } catch (error) {
                console.error("Fehler beim Abrufen der Legal-Einstellungen:", error);
            }
        }

        loadLegalSettings();
    }, []);


    const handleLogin = async () => {

        if (!privacyAccepted) {
            setAlertMessage("Bitte Datenschutzerklärung zustimmen!");

            return
        }

        setLoading(true);
        setAlertMessage("");

        try {
            const response = await fetch(`${API_BASE_URL}/api/login`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    name: name,
                    password: password
                })
            });

            const data = await response.json();

            console.log(data);
            console.log(JSON.stringify(data));

            if (data.valid) {
                window.location.href = "/";
                localStorage.setItem("session", JSON.stringify({ name: name, password: data.token }));
            } else {
                console.error("Login fehlgeschlagen");
                setAlertMessage("Name oder Passwort ist falsch!");
                setLoading(false);
            }
        } catch (error) {
            console.error(error);
            setAlertMessage("Login gerade nicht möglich. Bitte später erneut versuchen.");
            setLoading(false);

        }


    }


    return (

        <div className="login-container">
            <div className="login-box">

                <div className="form-floating mb-3">
                    <input
                        type="name"
                        className="form-control"
                        id="floatingInput"
                        placeholder="Name"
                        value={name}
                        onChange={(event) => setName(event.target.value)}
                    />
                    <label htmlFor="floatingInput">Name</label>
                </div>

                <div className="form-floating">
                    <input
                        type="password"
                        className="form-control"
                        id="floatingPassword"
                        placeholder="Password"
                        value={password}
                        onChange={(event) => setPassword(event.target.value)}
                    />
                    <label htmlFor="floatingPassword">Password</label>
                </div>

                {alertMessage && (
                    <div className="alert alert-danger login-alert" role="alert">
                        {alertMessage}
                    </div>
                )}
                <div className="dsgvo-box">
                    <input
                        type="checkbox"
                        name="privacyAccepted"
                        id="privacyAccepted"
                        checked={privacyAccepted}
                        onChange={(event) => setPrivacyAccepted(event.target.checked)}
                    />
                    <label htmlFor="privacyAccepted">
                        Ich habe die <Link to="/datenschutz" target="_blank" rel="noreferrer">Datenschutzerklärung</Link> gelesen und stimme ihr zu.
                    </label>
                </div>
                <button className="login-button" onClick={handleLogin} id="login-button" disabled={loading}>
                    {loading ? (
                        <>
                            <span className="spinner-border spinner-border-sm" aria-hidden="true"></span>
                            <span role="status">Loading...</span>
                        </>
                    ) : "Login"}
                </button>

                <nav className="login-legal-links" aria-label="Rechtliche Seiten">
                    <Link to="/datenschutz" target="_blank" rel="noreferrer">
                        Datenschutz
                    </Link>
                    {showImprint && (
                        <Link to="/impressum" target="_blank" rel="noreferrer">
                            Impressum
                        </Link>
                    )}
                </nav>

            </div>
        </div>

    );
}

export default Login;
